<template>
    <div class="page">
        <p>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br />
            {{ userStore.user.address }}
            <br />
            {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
        </p>
        <p>
            {{ creditor.creditor_name }}
            <br />
            <template v-if="creditor.address">
                {{ creditor.address }}
            </template>
            <template v-else>
                {{ creditor.address_line }}<br /> {{ creditor.city }}, {{ creditor.state }} {{ creditor.zipcode }}
            </template>
        </p>
        <p>
            Dear {{ creditor.creditor_name }}:
        </p>
        <p>
            Subject: Request Copy of 1099-C
        </p>
        <p>
            Account Number: {{ lodash.join(lodash.map(accounts, 'account_number'), ', ') }}
        </p>
        <p>
            Thank you for reading my request about this account with your company. I am writing today because during my quarterly review of my accounts listed on my credit report, I noticed that this account was charged off with {{ lodash.join(lodash.map(accounts, 'balance'), ', ') }}.
        </p>
        <p>
            I am requesting that your company please forward me a copy of the 1099-C that was issued by your company when you charged this debt off with the IRS which is required by law for all debts over $600.
        </p>
        <p>
            Please also enclose a printed copy of my payment history or you may also email it to me at {{ userStore.user.email }}. please do not send any marketing or other account information to this email address I have no desire to have spam at this location and I track everything by standard USPS mail at my home address listed above.
        </p>
        <p>
            If for some reason this was an error, please send me the past due amount that will re-establish my account into good standing with your company and payment will be provided within 5 business days of the written confirmation.
        </p>
        <p>
            Thanks in advance
        </p>
        <p>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br />
            {{ date }}
        </p>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    import lodash from 'lodash'
    export default {
        props: {
            accounts: {
                type: [Array, Object]
            },
            creditor: {
                type: [Array, Object]
            }
        },
        setup(props) {
            return {
                date: ref(moment().format('LL')),
                userStore: useUserStore(),
                lodash: lodash
            };
        },
    };
</script>
